/**
 * src/components/Financial/ChartAnalysisGate.jsx
 * 【完全修正版：認証・制限優先ロジック】
 */
import React, { useState, useEffect } from "react";
import { Lock, Key, Monitor, TrendingUp } from "lucide-react";
import CandleChartAnalysis from "./CandleChartAnalysis.jsx";

export default function ChartAnalysisGate(props) {
  const [isUnlocked, setIsUnlocked] = useState(() => {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return true;
    }
    return localStorage.getItem("astronica_chart_unlocked") === "true";
  });
  const [licenseKey, setLicenseKey] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [authError, setAuthError] = useState("");

  const [isMobile, setIsMobile] = useState(function () {
    return (
      window.innerWidth < 1024 ||
      /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    );
  });

  useEffect(function () {
    const handleResize = function () {
      setIsMobile(
        window.innerWidth < 1024 ||
          /Android|iPhone|iPad|iPod/i.test(navigator.userAgent),
      );
    };
    window.addEventListener("resize", handleResize);

    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleVerifyLicense = async function () {
    if (!licenseKey) return;
    setIsVerifying(true);
    setAuthError("");

    try {
      const response = await fetch("/api/verify-license", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: licenseKey }),
      });
      const data = await response.json();

      if (data.success) {
        setIsUnlocked(true);
        localStorage.setItem("astronica_chart_unlocked", "true");
      } else {
        setAuthError(data.message || "無効なライセンスキーです。");
      }
    } catch (err) {
      setAuthError("認証サーバーと通信できません。");
    } finally {
      setIsVerifying(false);
    }
  };

  // --- 判定ロジック 1: モバイル制限 (認証前でも表示) ---
  if (isMobile) {
    return (
      <div
        style={{
          height: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: props.isDarkMode ? "rgba(255,255,255,0.01)" : "#f9fafc",
          color: props.isDarkMode ? "#ffffff" : "#1e293b",
          padding: "30px",
          textAlign: "center",
          borderRadius: "12px",
        }}
      >
        <Monitor size={48} style={{ marginBottom: "20px", color: "#2c2d96" }} />
        <h2 style={{ fontSize: "22px", fontWeight: "bold", marginBottom: "15px" }}>
          PCブラウザからのみご利用できます
        </h2>
        <p style={{ fontSize: "15px", lineHeight: "1.6", color: "#64748b" }}>
          チャート分析機能は、高度な計算と詳細なグラフ表示のため、
          <br />
          デスクトップ環境に最適化されています。
        </p>
      </div>
    );
  }

  // --- 判定ロジック 2: ライセンス認証 (ダッシュボード全体で管理するため、ここでは常に通過) ---
  // 個別の isUnlocked 判定は削除しました。

  // --- 判定ロジック 3: 銘柄選択チェック (認証済みかつ未選択なら表示) ---
  if (
    !props.activeChartId ||
    !props.csvData ||
    props.csvData.length === 0
  ) {
    return (
      <div
        style={{
          height: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: props.isDarkMode ? "#94a3b8" : "#64748b",
          textAlign: "center",
          background: props.isDarkMode ? "rgba(255,255,255,0.01)" : "#fcfcfc",
          borderRadius: "12px",
          border: "1px dashed " + (props.isDarkMode ? "rgba(255,255,255,0.1)" : "#cbd5e1"),
        }}
      >
        <TrendingUp
          size={48}
          style={{ marginBottom: "20px", opacity: 0.2 }}
        />
        <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "10px", color: props.isDarkMode ? "#fff" : "#1e293b" }}>
          銘柄データをアップロードしてください
        </h2>
        <p style={{ fontSize: "14px", lineHeight: "1.6" }}>
          左メニューの「銘柄を追加(CSV)」からファイルをアップロードし、
          <br />
          リストから分析したい銘柄を選択してください。
        </p>
      </div>
    );
  }

  // --- 全て通過: チャート本体を表示 ---
  return (
    <CandleChartAnalysis
      csvData={props.csvData}
      chartName={
        (
          (props.uploadedCharts || []).find(function (c) {
            return c.id === props.activeChartId;
          }) || {}
        ).name || ""
      }
      observerLat={props.observerLat}
      observerLon={props.observerLon}
      aspectSettings={props.aspectSettings}
      planetColors={props.planetColors}
      isDarkMode={props.isDarkMode}
      natalPositions={props.natalPositions}
      onBack={function () {
        if (props.onClose) props.onClose();
      }}
    />
  );
}